/**
 * Helper: Analytics
 * -----------------------------------------------------------------------------
 * Analytics helper functions. e.g. for Klaviyo and GTM.
 * - Add in alphabetical order.
 *
 */

import { formatMoney } from '@shopify/theme-currency'

/**
 * Send Klaviyo an Add to Cart event.
 * @param {Array} selectedVariants - An array of variants that were supplied
 * to try to add to cart.
 * @param {Object} response - The successful cart response after adding
 * item(s) to cart.
 * @param {Array} response.items - The items that were successfully added to
 * cart.
 */
export function klaviyoAddToCart(selectedVariants, response) {
  const klaviyoItems = []
  response.items.forEach(item => {
    const variant = selectedVariants.find(variant => variant.id === item.id)
    let formattedItem = {}
    let compareAtPrice = variant?.compareAtPrice?.amount || variant.compareAtPrice

    if (compareAtPrice) {
      compareAtPrice = formatMoney(
        compareAtPrice,
        '${{amount}}',
      )
    }

    if (window.item) {
      formattedItem = { ...window.item }
    }

    formattedItem = {
      ...formattedItem,
      Brand: item.vendor,
      CompareAtPrice: compareAtPrice || '$0',
      ImageURL: item.image,
      Name: item.product_title,
      Price: formatMoney(item.price, '${{amount}}'),
      ProductID: item.product_id,
      URL: window.origin + item.url,
    }

    if (!formattedItem.Categories && variant?.product?.collections) {
      formattedItem.Categories = variant.product.collections.map(
        collection => collection.title,
      )
    }

    klaviyoItems.push(formattedItem)
  })

  sendKlaviyoAddCartEvent(klaviyoItems)
}

/**
 * Update Klaviyo profile
 * @param {Object} properties - The properties to update on the profile.
 */
export function klaviyoUpdateProfile(properties = {}) {
  window._learnq.push([
    'identify',
    { ...properties },
  ])
}

/**
 * Track GTM event.
 * @param {String} event - Name of event from Dormify
 * @param {String} label - Name of label from Dormify
 * @param {Object} data - Any additional data to attach.
 */
export function gtmTrack(event, label, data = {}) {
  window.dataLayer.push({
    event,
    label,
    ...data,
  })
}

/**
 * Send a list of items to Klaviyo. Stagger the events so Klaviyo registers
 * all of them.
 * @param items
 */
export function sendKlaviyoAddCartEvent(items) {
  if (items.length <= 0) {
    return
  }

  window._learnq.push([
    'track',
    'Added to Cart',
    items[0],
  ])

  setTimeout(() => {
    sendKlaviyoAddCartEvent(items.slice(1))
  }, 1000)
}

/**
 * Call Nosto callback to update mini cart recommendations
 */
export function updateNostoMiniCart() {
  if (window.Nosto && window.Nosto.reloadCart) {
    window.Nosto.reloadCart(['nosto-minicart-rec'])
  }
}
